import { Container, Sprite, Texture } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";

export class NewsItem extends Container {
    public readonly id: string;
    private readonly background: Sprite;
    private readonly placeholder: Sprite;
    protected readonly icon: Sprite;
    protected readonly newsResources: LatestNewsResourcePackage;

    public constructor(id: string, newsResources: LatestNewsResourcePackage, placeholderTexture: Texture, iconTexture: Texture) {
        super();
        this.id = id;
        this.newsResources = newsResources;
        this.background = new Sprite(newsResources.assets_views_latest_news_news_tooltip_background_png);
        this.placeholder = new Sprite(placeholderTexture);
        this.placeholder.position.set(196, 0);
        this.icon = new Sprite(iconTexture);
        this.addChild(this.background, this.placeholder, this.icon);
    }
}

export interface INewsItemOptions { }